import { render, staticRenderFns } from "./recept-renewal-orders.vue?vue&type=template&id=b63a3c28&scoped=true"
import script from "./recept-renewal-orders.vue?vue&type=script&lang=js"
export * from "./recept-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a3c28",
  null
  
)

export default component.exports